import React, { useState } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const PieChart = ({ voucherCounts }) => {
  const [selectedIndex, setSelectedIndex] = useState(null);

  const data = {
    labels: [
      "Coupon",
      "Memo",
      "Vakalatnama",
      "Sale deed/Gift deed",
      "Marriage Coupon",
      "Will/Attorney/Lease /Agreement",
      "Challan Coupon",
    ],
    datasets: [
      {
        data: voucherCounts,
        backgroundColor: [
          '#8A82E1',
          '#9C27B0',
          '#EFF326',
          '#FF9800',
          '#3B00ED',
          '#66D831',
          '#D81B60',
        ],
        hoverBackgroundColor: [
          '#8A82E1',
          '#9C27B0',
          '#EFF326',
          '#FF9800',
          '#3B00ED',
          '#66D831',
          '#D81B60',
        ],
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'right',
        labels: {
          boxWidth: 80, // Small square legend box size
          usePointStyle: true, // Use small square for labels
        },
      },
    },
    cutout: '70%', // Adjust this value to decrease the circle thickness
    onClick: (event, elements) => {
      if (elements.length > 0) {
        const index = elements[0].index;
        setSelectedIndex(index);
      }
    },
  };

  const selectedLabel = selectedIndex !== null ? data.labels[selectedIndex] : 'Coupon';
  const selectedValue = selectedIndex !== null ? data.datasets[0].data[selectedIndex] : voucherCounts[0];

  return (
    <div style={{ position: 'relative', width: '300px', height: 'auto' }}>
      <Doughnut data={data} options={options} />
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '25%',
          transform: 'translate(-50%, -50%)',
          textAlign: 'center',
        }}
      >
        <h2 style={{ margin: 0 }}>{selectedValue}</h2>
        <p style={{ margin: 0 }} className="text-small">{selectedLabel}</p>
      </div>
    </div>
  );
};

export default PieChart;
